import { render, staticRenderFns } from "./ReportOrdersProgress.vue?vue&type=template&id=f2b848d4"
import script from "./ReportOrdersProgress.vue?vue&type=script&lang=ts"
export * from "./ReportOrdersProgress.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports